import Navbar from "../Components/Navbar";
import ContactDetails from "../Components/ContactDetails";
import Footer from "../Components/Footer";

const Contact=()=>{
    return(
        <div className="contact">
            <Navbar />
            <ContactDetails/>
            <Footer />
        </div>
    )
}
export default Contact;